export default __webpack_public_path__ + "static/media/528.da1d0856.gif";